import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaMoon, FaSun } from 'react-icons/fa';

const ThemeToggle = () => {
  const [theme, setTheme] = useState('dark');

  // Apply theme when it changes
  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
    } else {
      document.documentElement.classList.add('light');
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Retrieve the saved theme on load
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'dark';
    setTheme(savedTheme);
  }, []);

  // Toggle theme
  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  return (
    <div
      className="relative flex items-center h-10 w-20 rounded-full bg-gray-300 dark:bg-gray-800 cursor-pointer p-1"
      onClick={toggleTheme}
    >
      {/* Moving Toggle Circle with bouncy effect!*/}
      <motion.div
        className="absolute h-8 w-8 rounded-full bg-white shadow-md flex items-center justify-center"
        layout
        initial={{ x: theme === 'dark' ? 0 : 40 }}
        animate={{ x: theme === 'dark' ? 0 : 40 }}
        transition={{
          type: 'spring',
          stiffness: 600,
          damping: 25,
        }}
      >
        {theme === 'dark' ? (
          <FaMoon className="text-yellow-500" size={18} />
        ) : (
          <FaSun className="text-orange-500" size={18} />
        )}
      </motion.div>
    </div>
  );
};

export default ThemeToggle;
